import yandex_icon from '../../../assets/images/icons/yandex_icon.webp'
import google_icon from '../../../assets/images/icons/google_icon.webp'
import double_gis_icon from '../../../assets/images/icons/double_gis_icon.webp'
import classes from './NavLinks.module.sass'
import { Link } from 'react-router-dom'

type Props = {
  yandex_route_url?: string
  google_route_url?: string
  double_gis_route_url?: string
}

export const NavLinks = ({ google_route_url, yandex_route_url, double_gis_route_url }: Props) => {
  
  return (
    <div className={classes.Anchor}>
      <div className={classes.Container}>
        {google_route_url && (
          <Link to={google_route_url} target="blank">
            <div className={classes.NavButton}>
              <img
                src={google_icon}
                className={classes.NavIcon}
                alt="Открыть в google навигаторе"
              />
            </div>
          </Link>
        )}
        {yandex_route_url && (
          <Link to={yandex_route_url} target="blank">
            <div className={classes.NavButton}>
              <img
                src={yandex_icon}
                className={classes.NavIcon}
                alt="Открыть в yandex навигаторе"
              />
            </div>
          </Link>
        )}
        {double_gis_route_url && (
          <Link to={double_gis_route_url} target="blank">
            <div className={classes.NavButton}>
              <img
                src={double_gis_icon}
                className={classes.NavIcon}
                alt="Открыть в double gis навигаторе"
              />
            </div>
          </Link>
        )}
      </div>
    </div>
  )
}
